import React from "react"
import DOMPurify from "dompurify"

export const getIfFieldsAreValid = (fields, workingObject) => {
  if (!Array.isArray(fields) || !workingObject) return false
  const allFieldsAreValid = fields.every(field => {
    const isMandatoryField = field?.mandatory
    if (!isMandatoryField) return true
    const concernedField = workingObject?.[field?.value]

    if ([null, undefined]?.includes(concernedField)) return false

    const isStringData = field?.dataType === "string"
    const isNumberData = field?.dataType === "number"
    const isArrayData = field?.dataType === "stringList"

    if (isStringData) return concernedField.trim() !== ""
    if (isNumberData) return typeof concernedField === "number"
    if (isArrayData) return Boolean(concernedField.length)
    return false
  })
  return allFieldsAreValid
}

export const getInputTypeAccordingData = dataType => {
  if (!dataType) return "text"
  const inputTypes = {
    string: "text",
    number: "number",
  }
  return inputTypes[dataType]
}

export const getFieldInitialValueAccordingData = dataType => {
  if (!dataType) return ""
  const initialValues = {
    string: "",
    number: 0,
    stringList: [],
    arrayOfStrings: [],
  }
  return initialValues[dataType]
}

export const getChoiceListOptions = (choicesList, listId) => {
  if (!Array.isArray(choicesList) || !listId) return []
  const choiceListAssociate = choicesList.find(list => list?._id?.$oid === listId)
  if (!choiceListAssociate) return []
  return choiceListAssociate?.option
}

// --------------------------------------------------------//
// ---- Custom fields columns / render in table -------------//
// --------------------------------------------------------//
export const generateCustomFieldsColumns = (customFields, choicesList, onRowSelected, type) => {
  if (!Array.isArray(customFields) || !Array.isArray(choicesList)) return []
  return customFields.reduce((acc, field) => {
    if (!field?.appearsInGlobalVisu) return acc
    const fieldName = field.value ? field.value.toUpperCase() : ""
    const newColumn = {
      headerName: fieldName,
      field: field.value,
      wrapText: true,
      autoHeight: true,
      cellStyle: { display: "flex", justifyContent: "center" },
      cellRenderer: customFieldsCellRenderer(customFields, choicesList, onRowSelected, type),
    }
    return [...acc, newColumn]
  }, [])
}

export const customFieldsCellRenderer = (customFields, choicesList, onRowSelected, type) => {
  if (!Array.isArray(customFields)) return null
  return cell => {
    const customFieldsValues = cell?.data?.customFields
    const field = customFields.find(field => field?.value === cell?.colDef?.field)
    if (!field) return null
    const cellValue = getCustomFieldCellValue(field, customFieldsValues, choicesList)
    const handleClick = () => {
      onRowSelected(cell, type) || console.log("OnRowSelected is not a function")
    }

    if (field?.fieldType === "textArea") {
      const sanitizedValue = DOMPurify.sanitize(cellValue)

      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: sanitizedValue }} />
        </div>
      )
    } else {
      return (
        <div onClick={handleClick} className="">
          {cellValue}
        </div>
      )
    }
  }
}
export const getCustomFieldCellValue = (customField, customFieldsValues, choicesList) => {
  if (!customField || !customFieldsValues || !Array.isArray(choicesList)) return ""
  const fieldValue = customField?.value
  if (!fieldValue) return ""
  const isSelectField = ["select", "multiSelect"].includes(customField?.fieldType)
  if (!isSelectField) {
    return customFieldsValues[fieldValue] ? customFieldsValues[fieldValue] : ""
  } else {
    const optionListId = customField.optionsListId
    const selectedOption = customFieldsValues[fieldValue]
    if (!optionListId || !selectedOption) return ""
    const choiceListAssociate = choicesList.find(list => list?._id?.$oid === optionListId)
    if (!choiceListAssociate) return ""
    const choiceListOptions = choiceListAssociate.option || []
    // Si c'est un selecteur multiple on a directement les labels dans nos valeurs de champs customs
    if (Array.isArray(selectedOption)) {
      return selectedOption.map(opt => opt?.label).join(",")
    }
    // Si c'est un selecteur simple on a que l'id et on doit trouver l'option correspondante puis afficher son label
    const foundOption = choiceListOptions.find(option => option?.value === selectedOption)
    return foundOption?.label || ""
  }
}
